// extracted by mini-css-extract-plugin
export default {"title":"aaa-z","warning":"baa-z","sizeOptionsLegendText":"caa-z"};